(function($, Drupal) {
  // Ecommerce slider.
  Drupal.behaviors.eCommerceSlider = {
    attach: function(context, settings) {
      var variationsSlider = $(".ecommerce-variations-slider-wrapper");

      var breakpoints = [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true
          }
        }
      ];

      if (variationsSlider.closest(".view-display-id-block_2").length > 0) {
        breakpoints = [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerMode: true
            }
          }
        ];
      }

      variationsSlider.not('.slick-initialized').slick({
        slidesToShow: 3,
        arrows: true,
        dots: false,
        responsive: breakpoints
      });

      $(".ecommerce--A", context).each(function() {
        let $this = $(this);

        if ($(this).hasClass("ecommerce--bundle")) {
          function setSlider() {
            let $el = $this.find(".js_ecommerce-slider").css("opacity", "1"),
              $nav_slider = $el.find(".ecommerce__images"),
              $main_slider = $el.find(".ecommerce__image"),
              $resPixel = $(".js_resolution"),
              $nav_sliderItems = $nav_slider.children().length;
            // Main slider.

            $main_slider.not('.slick-initialized').slick({
              slidesToShow: 1,
              arrows: false,
              fade: true,
              asNavFor: $nav_slider
            });

            // Navigational slider.
            $nav_slider.not('.slick-initialized').slick({
              slidesToShow: $nav_sliderItems,
              asNavFor: $main_slider,
              dots: false,
              arrows: false,
              centerMode: true,
              focusOnSelect: true,
              vertical: false,
              verticalSwiping: false
            });
          }

          setSlider();

          $(document).ajaxComplete(function(event, xhr, settings) {
            if (settings.url.indexOf("drupal_ajax") > -1) {
              setTimeout(function() {
                if(!$('.js_ecommerce-slider').hasClass('slick-initialized')) {
                  setSlider();
                }
              }, 1000);
            }
          });
        } else {
          function setSlider() {
            let $el = $this.find(".js_ecommerce-slider").css("opacity", "1"),
              $nav_slider = $el.find(".ecommerce__images"),
              $main_slider = $el.find(".ecommerce__image"),
              $resPixel = $(".js_resolution"),
              $nav_sliderItems = $nav_slider.children().length;
            // Main slider.
            $main_slider.not('.slick-initialized').slick({
              slidesToShow: 1,
              arrows: false,
              fade: true,
              asNavFor: $nav_slider,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    dots: true,
                    asNavFor: false
                  }
                }
              ]
            });

            // Navigational slider.
            $nav_slider.not('.slick-initialized').slick({
              slidesToShow: $nav_sliderItems,
              asNavFor: $main_slider,
              dots: false,
              arrows: false,
              centerMode: true,
              focusOnSelect: true,
              vertical: false,
              verticalSwiping: false,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    vertical: false,
                    verticalSwiping: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: "unslick"
                }
              ]
            });

            if ($resPixel.css("opacity") < "0.5") {
              $nav_slider.remove();
            }
          }

          setSlider();

          $(document).ajaxComplete(function(event, xhr, settings) {
            if (settings.url.indexOf("drupal_ajax") > -1) {
              setTimeout(function() {
                if(!$('.js_ecommerce-slider').hasClass('slick-initialized')) {
                  setSlider();
                }
              }, 1000);
            }
          });
        }
      });
    }
  };
})(jQuery, Drupal);
